import React, {useState } from 'react';
import { UsernameSelector2 } from '../Utils/Selectors/UsernameSelector';
import ClientSelector from '../Utils/Selectors/ClientSelector';
import { useAppContext } from '../../context';
import { BillingCenterSelector } from '../Utils/Selectors/BillingCenterSelector';

function BillingCenterAndClient({ expedition, byOps = false, onChange }) {

    const [customer, setCustomer] = useState(expedition?.billing_center.customer_id);
    const [value, setValue] = useState(expedition?.user?.id);
    const [billingCenterId, setbillingCenterId] = useState(expedition?.billing_center_id);
    const [username, setUsername] = useState(expedition?.username);
    const { isAuth } = useAppContext();

    const handleBilling = (data) => {
        onChange("billing_center_id", data?.value)
        setbillingCenterId(data?.value)
        // setValue("")
    }

    const handleUsername = (data) => {
        onChange("user_id", data)
        setValue(data)
    }

    return (
        <div className="text-base ">
            <div className='grid grid-cols-1 gap-1 md:gap-6 card-body md:grid-cols-2'>

                {/* src/components/shippingDetails */}

                <div className={'my-2'}>
                    <label htmlFor="" className='titre-detail'>Créé par </label>
                    <input
                        type="text"
                        className="w-full bg-white border border-gray-500 rounded-lg outline-none form-control"
                        id="numero_compte"
                        placeholder="Nom du demandeur"
                        value={expedition?.created_by?.name}
                        onChange={(valeur) => {
                            console.log(valeur)
                        }}
                    />

                </div>

                <div className={'my-2'}>
                    <label htmlFor="" className='titre-detail'>Compte client lié </label>
                    <ClientSelector
                        type={isAuth?.spaceName}
                        selectedValue={customer}
                        showLabel={false}
                        profil={"customer"}
                        onSelect={(v) => {
                            setCustomer(v.value);
                        }}
                    />
                </div>

                <div className={'my-2'}>
                    <BillingCenterSelector
                        user={customer}
                        showLabel={true}
                        onSelect={handleBilling}
                        selectedValue={billingCenterId}
                    />
                </div>

                <div className={'my-2'}>
                    <label htmlFor="" className='titre-detail'>Compte utilisateur lié </label>
                    <UsernameSelector2
                        customer_id={customer}
                        onSelect={(value) => handleUsername(value.value)}
                        defaultValue={value}
                        billing_center_id={billingCenterId}
                    />
                </div>

                <div className={'my-2 form-group'}>
                    <label className='titre-detail'>
                        Nom de demandeur
                    </label>
                    <input
                        type="text"
                        className="w-full bg-white border border-gray-500 rounded-lg outline-none form-control"
                        id="numero_compte"
                        placeholder="Nom du demandeur"
                        value={username}
                        onChange={(e) => {
                            onChange("username", e.target.value)
                            setUsername(e.target.value)
                        }}
                    />
                </div>

            </div>
        </div>
    );
}

export default BillingCenterAndClient;